import { atom } from "recoil"

export const isBigPlayIconState = atom({
  key: "isBigPlayIconState",
  default: false
})
